import React from 'react'

const IconArrowUp = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.0001 10.1078L7.40013 14.7078L6.69238 14L12.0001 8.69226L17.3079 14L16.6001 14.7078L12.0001 10.1078Z'
        fill='#242424'
      />
    </svg>
  )
}

export default IconArrowUp
